import React, { useEffect, useState } from 'react'
import { CCol, CForm, CFormInput, CFormLabel, CInputGroup, CInputGroupText, CRow } from '@coreui/react'
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Button } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useModifier } from '../contexts/ModifiersContext'
import { useCompanySetting } from '../contexts/CompanySettingContext';
import CInput from './CInput';

function AddModifiers({ id, modifierDetail, editModifierId, visible, setVisible, setEditModifierId, editMode, setEditMode, setModifierDetail, fetchModifiers, canCreate, canUpdate, canDelete }) {
    const { getSingleModifier, createModifier, updateModifier, deleteModifier } = useModifier()
    const { toast, restaurantId } = useAuth()
    const { currency } = useCompanySetting()

    const [validated, setValidated] = useState(false);

    const handleClose = () => {
        setVisible(false);
        setEditMode(false);
        setEditModifierId(null);
        setModifierDetail({
            name: "",
            display_name: "",
            price: 0,
            modifiers: [],
            restaurant_id: restaurantId
        })
    };

    const fetchSingleModifier = async () => {
        try {
            const modifier = await getSingleModifier(id);
            setModifierDetail(modifier);
        } catch (error) {
            console.error('Error fetching single modifier', error);
        }
    };

    useEffect(() => {
        if (editMode && editModifierId) {
            fetchSingleModifier();
        }
    }, [editMode, editModifierId]);

    const handleDelete = async () => {
        try {
            const confirmed = await confirmDelete();

            if (confirmed) {
                const data = await deleteModifier(id);
                if (!data.error) {
                    setTimeout(function () {
                        toast.current?.show({ severity: 'success', summary: 'Modifier', detail: data.message, life: 3000 })
                    }, 500);
                    handleClose();
                    fetchModifiers()
                } else {
                    toast.current?.show({ severity: 'error', summary: 'Modifier', detail: data.message, life: 3000 })
                }
            }
        } catch (error) {
            console.error('Error during delete operation', error);
        }
    };

    const confirmDelete = async () => {
        return new Promise((resolve) => {
            confirmDialog({
                message: 'Are you sure you want to delete this modifier?',
                header: 'Delete Confirmation',
                icon: 'pi pi-info-circle',
                position: 'top',
                accept: () => resolve(true),
                reject: () => resolve(false),
            });
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if ((editMode && !canUpdate) || (!editMode && !canCreate)) return;
        
        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (visible && restaurantId) {
                    const data = await createModifier({ ...modifierDetail, restaurant_id: restaurantId })
                    if (!data.error) {
                        fetchModifiers(data.modifier)
                        handleClose()
                    }
                } else if (editMode && editModifierId && restaurantId) {
                    const data = await updateModifier(id, { ...modifierDetail, restaurant_id: restaurantId })
                    if (!data.error) {
                        handleClose()
                        fetchModifiers()
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    return (
        <div>
            <ConfirmDialog />
            <Dialog draggable={false} header={`${visible ? 'Create Modifier' : 'Edit Modifier'}`} visible={visible || (editMode && editModifierId !== null)} style={{ width: '35vw' }} onHide={handleClose}>
                <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                    <div className='fields-container'>
                        <CRow className='mb-4 mt-4'>
                            <CInput
                                label={'Name'}
                                type={'text'}
                                className={'d-flex'}
                                labelClassName={'w-50'}
                                value={modifierDetail.name}
                                onChange={(value) => setModifierDetail({ ...modifierDetail, name: value })}
                                required={true}
                                errorMessage='Name is required.'
                            />
                        </CRow>
                        <CRow className='mb-4'>
                            <CInput
                                label={'Display Name'}
                                type={'text'}
                                className={'d-flex'}
                                labelClassName={'w-50'}
                                value={modifierDetail.display_name}
                                onChange={(value) => setModifierDetail({ ...modifierDetail, display_name: value })}
                            />
                        </CRow>
                        <CRow className="mb-4">
                            <div className='d-flex'>
                                <CFormLabel className="form-label w-50">Price <span className="text-danger">*</span></CFormLabel>
                                <CInputGroup>
                                    <CInputGroupText id="basic-addon1">
                                        {currency}
                                    </CInputGroupText>
                                    <CFormInput
                                        type="number"
                                        step="any"
                                        value={modifierDetail.price}
                                        min={0}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (newValue >= 0) {
                                                setModifierDetail({ ...modifierDetail, price: newValue })
                                            }
                                        }}
                                        required
                                        feedbackInvalid='Price is required.'
                                    />
                                </CInputGroup>
                            </div>
                        </CRow>
                    </div>
                    <div className={`d-flex mt-4 button-container ${(editMode && editModifierId && canDelete) ? 'justify-content-between' : 'justify-content-end'}`}>
                        {
                            (editMode && editModifierId && canDelete) && (
                                <div>
                                    <Button color='error' variant="contained" onClick={handleDelete} className='me-2'>
                                        Delete
                                    </Button>
                                    {/* <Button color='info' variant="contained" className='me-2'>
                                        Copy
                                    </Button> */}
                                </div>
                            )
                        }
                        <div className='d-flex'>
                            <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            {((!editMode && canCreate) || (editMode && canUpdate)) && (
                                <Button fullWidth variant="contained" color="primary" type="submit" className="ms-3">
                                    Submit
                                </Button>
                            )}
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </div>
    )
}

export default AddModifiers